var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".up_svg__a_JNQ2A4RK{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "up_svg__a_JNQ2A4RK",
    d: "M0 0h44v44H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "up_svg__a_JNQ2A4RK",
    d: "M10 10h24v24H10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 20.12 11.819 14 18 7.88 16.1 6 8 14l8.1 8Z",
    transform: "rotate(90 13.5 22.5)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgUp;